import environment                      from '../../app.environment';

const API_URL = environment.REACT_APP_API_URL;

function handleResponse(response) {
  return response.json()
    .catch((response) => {

      return Promise.reject(response.status);
    }).then(json => {

    if (response.ok) {
      return json;
    }

    return Promise.reject(json);
  });
};

const ProviderCredentialService = {

  getAllCredentials: async function() {
    return fetch(`${API_URL}/credentials`)
      .then(handleResponse)
  },

  getCapabilities: async function() {
    return fetch(`${API_URL}/credentials/capabilities`)
      .then(handleResponse)
  },

  getProviderCredential: async function(id) {
    return fetch(`${API_URL}/credentials/${id}`)
      .then(handleResponse)
  },

  getAvailableProviders: async function() {
    return fetch(`${API_URL}/credentials/providers`)
      .then(handleResponse)
  },

  saveCredentials: async function(data) {
    let reqOptions = {
      method: "post",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(data)
    };
    return fetch(`${API_URL}/credentials`, reqOptions)
      .then(handleResponse)
  },

  updateCredentials: async function(data) {
    let reqOptions = {
      method: "put",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(data)
    };
    return fetch(`${API_URL}/credentials/${data.id}`, reqOptions)
      .then(handleResponse)
  },

  deleteCredentials: async function(id) {
    let reqOptions = {
      method: "delete"
    };
    return fetch(`${API_URL}/credentials/${id}`, reqOptions)
      .then(handleResponse)
  },

  getAvailableCredentialsForOrganization: async function(organizationId) {
    return fetch(`${API_URL}/credentials?organizationId=${organizationId}`)
      .then(handleResponse)
  }
};

export default ProviderCredentialService;